/**
 * Owner: Haselton Baker Risk Group, LLC
 * Product: SP3 - SP3-Risk-Model-UI
 * Developer: Mike McGlone <mike@hbrisk.com>
 * Date: 2019-06-28
 * Copyright All Rights Reserved
 */
// @flow
import classNames from 'classnames';
import * as React from 'react';
import { Col } from 'reactstrap';
import { sidebar, sidebarSticky } from './Sidebar.module.scss';

type Props = {
  children: React.Node,
}
const Sidebar = ({ children }: Props) => (
  <Col md="3" className={classNames(['d-none', 'd-none d-md-block', sidebar])}>
    <div className={sidebarSticky}>
      {children}
    </div>
  </Col>
);

export default Sidebar;



// WEBPACK FOOTER //
// ./js/components/support/layout/Sidebar/Sidebar.jsx